module.exports = ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}"